// config.js
class Config {
  /**
  * Construtor
  * @param {Object} config - objeto de configuracao a ser carregado
  */
  constructor(config) {
    this.cfg = config;
  }

  /**
  * Lê da configuração se o controle sera visivel. Caso não exista a chave
  * é retornado o valor padrão
  * @param {String} key - chave de configuração a ser pesquisada
  * @param {Boolean} def - valor padrão caso a chave não esteja definida
  * @return  Verdadeiro para controle que sera visivel, caso contrario
  * e retornado falso
  */
  isVisible(key, def) {
    return this.lookup(key, def, 'visible');
  }

  /**
  * Lê da configuração se o controle será somente leitura. Caso não exista a chave
  * é retornado o valor padrão
  * @param {String} key chave de configuração a ser pesquisada
  * @param {Boolean} def valor padrão caso a chave não esteja definida
  * @return Verdadeiro para controle que sera somente leitura, caso contrario
  * e retornado falso
  */
  isReadOnly(key, def) {
    return this.lookup(key, def, 'readonly');
  }

  /**
  * Lê da configuração se o controle é requerido. Caso não exista a chave
  * é retornado o valor padrão
  * @param {String} key chave de configuração a ser pesquisada
  * @param {Boolean} def valor padrão caso a chave não esteja definida
  * @return Verdadeiro para controle sera requerido, caso contrario
  * e retornado falso
  */
  isRequired(key, def) {
    return this.lookup(key, def, 'required');
  }

  /**
  * Lê da configuração se o controle é marcado. Caso não exista a chave
  * é retornado o valor padrão
  * @param {String} key chave de configuração a ser pesquisada
  * @param {Boolean} def valor padrão caso a chave não esteja definida
  * @return Verdadeiro para controle sera requerido, caso contrario
  * e retornado falso
  */
  isChecked(key, def) {
    return this.lookup(key, def, 'checked');
  }

  /**
  * Lê da configuração o rotulo do controle. Caso não exista a chave
  * é retornado o valor padrão
  * @param {String} key chave de configuração a ser pesquisada
  * @param {String} def valor padrão caso a chave não esteja definida
  * @return O texto a ser aplicado no controle
  */
  getLabel(key, def) {
    return this.lookup(key, def, 'label');
  }

  getLabelCombo(key) {
    return this.lookup(key, '', 'labelcombo');
  }

  getValor(key, def) {
    return this.lookup(key, def);
  }

  static getTipoConselho() {
    return 'CRM';
  }

  get getUF() {
    return this.lookup('cliente.uf', 'MG');
  }

  static getPercentualAutorizacao() {
    return 100;
  }

  static getFormatDate() {
    return 'DD/MM/YYYY';
  }

  static getFormatDateTime() {
    return 'DD/MM/YYYY HH:mm';
  }

  getMsg(key, def) {
    return this.lookup(key, def);
  }

  get getCliente() {
    return this.lookup('cliente.id', {});
  }

  get getNomeCliente() {
    return this.lookup('cliente.nome', {});
  }

  get getIdAnalytics() {
    return this.idAnalytics;
  }

  /**
  * Lê da configuração a mascara do controle. Caso não exista a chave
  * é retornado o valor padrão
  * @param {String} key chave de configuração a ser pesquisada
  * @param {String} def valor padrão caso a chave não esteja definida
  * @return O texto a ser aplicado no controle
  */
  getMask(key, def) {
    return this.lookup(key, 'mask', def);
  }

  /**
  * Lê da configuração a mascara do controle. Caso não exista a chave
  * é retornado o valor padrão
  * @param {String} key chave de configuração a ser pesquisada
  * @param {*} def valor padrão caso a chave não esteja definida
  * @param {String} type Tipo a ser localizado
  * @return Valor configurado
  */
  lookup(key, def, type = '') {
    const p = type === '' ? '' : `.${type}`;
    const r = Config.resolvePath(`${key}${p}`, this.cfg);
    return r === undefined ? def : r;
  }

  /**
   * Classe que resolve atraves do caminho
   * o valor do objeto.
   * @param {*} path Caminho a ser resolvido
   * @param {*} obj  Objeto que sera pesquisado
   * @return Se o valor for encontrado e retornado
   * o seu conteúdo, caso contrario e retornado
   * undefined
   */
  static resolvePath(path, obj) {
    return path.split('.').reduce((v, k) => {
      if (v !== undefined) return v[k];
      return undefined;
    }, obj);
  }
}

export default {
  install: (app, options) => {
    app.config.globalProperties.$config = new Config(options.ConfigApp);
  },
};
